<template>
  <div>
    <el-button type="primary" icon="el-icon-plus" @click="dialogVisible = true">添加</el-button>
    <el-dialog :visible="dialogVisible" title="新建项目" width="1000px" @close="closeDialog">
      <el-form :model="detail" ref="form" :rules="rules" label-width="120px">
        <el-form-item label="币种：" prop="coinType">
          <el-select v-model="detail.coinType" placeholder="请选择">
            <el-option v-for="item in coinTypeList" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="数量：" prop="amount">
          <el-input-number v-model="detail.amount" :min="1"></el-input-number>
        </el-form-item>

        <el-form-item label="执行时间：" required>
          <el-form-item prop="executeTime">
            <el-date-picker
              v-model="detail.executeTime"
              value-format="timestamp"
              placeholder="选择执行时间"
              type="datetime"
            ></el-date-picker>
          </el-form-item>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSave()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Editor from "components/editor";
import Upload from "components/upload";
import LANGUAGE from "common/languages";

export default {
  name: "foundationCreate",
  data() {
    const validateEndTime = (rule, value, callback) => {
      if (!this.detail.endTime) {
        callback(new Error("请填写"));
      }
      if (
        this.detail.startTime &&
        this.detail.endTime &&
        value < this.detail.startTime
      )
        callback(new Error("截止时间不得早于开始时间"));
      callback();
    };
    const validateStartTime = (rule, value, callback) => {
      if (!this.detail.startTime) {
        callback(new Error("请填写"));
      }
      if (this.detail.startTime < new Date())
        callback(new Error("开始时间不得早于当前时间"));
      callback();
    };
    return {
      dialogVisible: false,
      detail: {
        distributionCoinType: "",
        foundationType: "",
        buyLimit: ""
      },
      options: [
        {
          value: "0",
          label: "PC和APP"
        },
        {
          value: "1",
          label: "PC"
        },
        {
          value: "2",
          label: "APP"
        }
      ],
      types: [
        { value: "0", label: "普通抢购项目" },
        { value: "1", label: "新人专场" }
      ],
      rules: {
        coinType: {
          required: true,
          message: "请填写"
        },
        amount: {
          required: true,
          message: "请填写"
        },
        executeTime: {
          required: true,
          message: "请填写"
        }
      }
    };
  },
  components: {
    Editor,
    Upload
  },
  computed: {
    ...mapState("orderTaskProject", ["coinTypeList", "languageList"])
  },
  methods: {
    ...mapActions("orderTaskProject", ["create"]),
    closeDialog() {
      this.dialogVisible = false;
      this.detail = {};
      this.$refs["form"].resetFields();
    },
    handleSave() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          this.doSave();
        }
      });
    },
    doSave() {
      this.create(this.detail).then(() => {
        this.$message({
          message: "添加成功！",
          type: "success"
        });
        this.dialogVisible = false;
        this.$emit("refresh", {
          page: 1
        });
      });
    }
  }
};
</script>

<style lang="less">
.editor {
  height: 500px;
}
</style>
